export const MESSAGES_EN = {
  secure_tagadapay: 'Secure Checkout by Tagada',
  checkout_title: 'Secure Checkout',
  checkout_subtitle: 'Complete your purchase securely',
  express_payment: 'Express Payment',
  express_payment_apple_pay: 'Pay',
  express_payment_subtitle: 'Skip the checkout form',
  informations_title: 'Informations',
  informations_subtitle: 'Enter your personal information',
  shipping_address_title: 'Shipping Address',
  shipping_address_subtitle: 'Enter your shipping address',
  shipping_method_title: 'Shipping Method',
  shipping_method_subtitle: 'Select your shipping method below',
  shipping_method_warning_title: 'Information',
  shipping_method_warning_text: 'No shipping method found in your country',
  billing_address_check: 'Billing address is different from shipping address',
  billing_method_title: 'Billing Method',
  billing_method_subtitle: 'Enter your billing address',
  payment_title: 'Payment',
  payment_subtitle: 'Select your payment method below. All transactions are secure and encrypted',
  payment_credit_card: 'Credit or debit Card',
  payment_credit_card_subtitle: 'Secure card payment',
  payment_paypal_subtitle: 'Secure and fast payment with PayPal',
  payment_bridge_subtitle: 'Secure and fast payment with Bridge',
  payment_klarna_subtitle: 'Secure and fast payment with Klarna',
  payment_generic_subtitle: 'Secure and fast payment',
  default_payment_method_short: 'Default',
  order_summary_discount_code: 'Discount code',
  order_summary_discount_discovered_callout: 'We found discount codes for you!',
  order_summary_discount_discovered_callout_action: 'Add them all',
  order_summary_title: 'Your order',
  order_summary_subtotal: 'Subtotal',
  order_summary_shipping: 'Shipping',
  order_summary_discount: 'Discount',
  order_summary_tax: 'Estimated taxes',
  order_summary_total: 'Total',
  order_summary_total_savings: 'Savings',
  button_pay: 'Pay now',
  button_pay_with_gateway: 'Pay with {gateway}',
  loading: 'Loading...',
  error_missing_checkout_session_id: 'Missing checkout session id',
  error_checkout_session_not_found: 'Checkout session not found',
  error_order_already_completed: 'Order already completed',
  error_checkout_session_items_empty: 'Your checkout is empty',
  order_not_found: 'Order not found',
  thank_you_title: 'Thank you for your order!',
  thank_you_subtitle: 'Your order has been successfully placed.',
  thank_you_email_sent: "We've sent a confirmation email to your registered email address :",
  thank_you_order_details: 'Order Details',
  thank_you_reference: 'Reference',
  thank_you_date: 'Date',
  thank_you_total: 'Total',
  thank_you_button_continue: 'Continue Shopping',
  term_and_privacy_clicking_text: 'By clicking this, i agree to',
  term_and_condition_link_text: 'Terms & Conditions',
  privacy_policy_link_text: 'Privacy Policy',
  refund_policy_link_text: 'Refund Policy',
  shipping_policy_link_text: 'Shipping Policy',
  billed_as_text: 'Your credit card will be billed as {domain}.',
  you_must_accept_policies: 'You must accept our',
  and: 'and',
  comma: ',',
  payment_error_title: 'Error',
  checkout_preview_title: 'Preview Mode - This is a draft checkout page',
  order_summary_discount_code_apply_button: 'Apply',
  optional: 'Optional',
  field_phone: 'Phone',
  field_phone_placeholder: 'Enter your phone number',
  field_phone_required_text: 'Phone number is required',
  field_company: 'Company',
  field_company_placeholder: 'Enter your company name',
  checkbox_billing_address: 'Billing address is different from shipping address',
  billing_address_title: 'Billing Address',
  billing_address_subtitle: 'Enter your billing address',
  field_first_name: 'First Name',
  field_first_name_placeholder: 'Enter your first name',
  field_first_name_error_message: 'This field is required',
  field_last_name: 'Last Name',
  field_last_name_placeholder: 'Enter your last name',
  field_last_name_error_message: 'This field is required',
  field_address: 'Address',
  field_address_placeholder: '123 Main St, City, Country',
  field_address_error_message: 'This field is required',
  field_additional_address: 'Additional Address',
  field_additional_address_placeholder: 'Apartment, suite, unit, etc.',
  field_additional_address_error_message: 'This field is required',
  field_city: 'City',
  field_city_placeholder: 'Enter your city',
  field_city_error_message: 'This field is required',
  field_country: 'Country',
  field_country_error_message: 'This field is required',
  field_state: 'State',
  field_state_placeholder: 'Enter your state',
  field_state_error_message: 'This field is required',
  field_postal_code: 'Postal Code',
  field_postal_code_placeholder: 'Enter your postal code',
  field_postal_code_error_message: 'This field is required',
  field_email: 'Email',
  field_email_placeholder: 'Enter your email',
  field_email_error_message: 'This field is required',
  credit_card_method: 'Credit or debit Card',
  card_error_message: 'Invalid card information',
  card_number: 'Card number',
  card_number_placeholder: 'Enter your card number',
  card_number_error_message: 'This field is required',
  expiry_date: 'Expiry date',
  expiry_date_placeholder: 'MM/YY',
  expiry_date_error_message: 'This field is required',
  expiry_date_error_message_expired: 'Expiry date has passed',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'CVC must be 3 or 4 digits',
  payment_methods_loading_error: 'Failed to load payment methods',
  recommanded: 'Recommended',
  free: 'Free',
  customer_update_error: 'Failed to update information',
  shipping_method_empty_country: 'Select a country to see available shipping methods',
  shipping_method_update_error: 'Failed to update shipping method information',
  items: '{count} items',
  back: 'Back',
  continue_to_shipping: 'Continue to shipping',
  continue_to_payment: 'Continue to payment',
  contact_title: 'Contact',
  contact_title_subtitle: 'Enter your contact information',
  pay_now: 'Pay now',
  secure_payment_message: 'All transactions are secure and encrypted',
  interval_day: 'day',
  interval_week: 'week',
  interval_month: 'month',
  interval_year: 'year',
  interval_day_plural: 'days',
  interval_week_plural: 'weeks',
  interval_month_plural: 'months',
  interval_year_plural: 'years',
  every_interval: 'Every {count} {interval}',
  billing_every_interval: 'Billing every {count} {interval}',
  delivery_every_interval: 'Delivery every {count} {interval}',
  free_trial_period: '{duration} {type} free trial',
  first_payment_free: 'First payment free',
  subscription_trial_notice:
    "Your subscription includes a free trial period. You won't be charged until the trial ends.",
  recurring_total_with_interval: 'Recurring total (every {count} {interval})',
  trial_ends_on: 'Trial ends on {date}',
  billing_timing: 'Billing: {timing}',
  billing_cycle_anchor: 'Billing cycle anchor',
  field_marketing_label: 'Agree to receive marketing emails',
  terms_acceptance_text: 'By clicking this, I agree to',
  cart_title: 'Cart',
  payment_failed_message: 'Payment failed',
  email: {
    abandoned_checkout: {
      preview: 'Complete your purchase',
      default_body: 'We noticed you left some items in your cart. Would you like to complete your purchase?',
      cart_title: 'Your Cart',
      quantity: 'Quantity',
      recurring: 'Recurring {interval}ly',
      trial_period: '({duration} {type} trial)',
      subtotal: 'Subtotal',
      discounts: 'Discounts',
      total: 'Total',
      cta_button: 'Complete your purchase',
      footer_text: "If you have any questions, just reply to this email - we're always happy to help.",
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'Unauthorized',
      unsupported_content_type: 'Unsupported content type',
      single_file_required: 'A single file is required',
      file_too_big: 'The file is too big',
      non_image_file: "Can't handle non image files",
    },
  },
  promotion_code_invalid: 'This discount code is not valid',
  applying: 'Applying...',
  processing_payment: 'Processing payment...',
  select_country: 'Select a country',
  select_state: 'Select a state',
  order_details: 'Order Details',
  order_number: 'Order Number',
  order_date: 'Order Date',
  email_confirmation: 'Email Confirmation',
  confirmation_sent_to: 'Confirmation email sent to',
  shipping_address: 'Shipping Address',
  billing_address: 'Billing Address',
  payment_successful: 'Payment Successful',
  recurring_total: 'Recurring Total',
  payment_is_blacklisted: 'Payment is blacklisted',
  checkout_has_errors_title: 'Validation',
  checkout_has_errors: 'The information below is invalid or missing',
  checkout_email_error: 'email address',
  checkout_shipping_address_error: 'shipping address',
  checkout_billing_address_error: 'billing address',
  checkout_shipping_rate_error: 'shipping rate',
  checkout_pickup_address_error: 'pickup address',
  checkout_payment_info_error: 'payment information',
  checkout_phone_error: 'phone number',
  checkout_terms_error: 'you have not accepted the terms and conditions',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'An unexpected error occurred. Please try again.',
  },
  checkout_completed_title: 'Checkout Completed',
  checkout_already_completed: 'This order has already been paid for',
  payment_completed: 'Payment Completed',
  apply_vip_offers: 'Pay Now as VIP',
  confirm_vip_payment: 'Confirm VIP Payment',
  cancel_vip_offers: 'Cancel VIP offers',
  vip_total_difference: 'Difference: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'VIP Savings',
  vip_savings_available: 'VIP Savings Available',
  vip_savings_confirmed: 'VIP Savings Applied',
  vip_savings_message: 'Select VIP payment to unlock these savings!',
  vip_savings_applied_message: 'You are saving {amount} with VIP benefits!',
  vip_offer_savings_confirmed: 'VIP Offer Applied',
  vip_offer_savings_available: 'VIP Offer Available',
  vip_offer_savings_message: 'Apply the VIP offer to save on your order',
  vip_offer_savings_applied_message: 'You saved {amount} with the VIP offer',
  apply_vip_offer: 'Apply VIP Offer',
  cancel_vip_offer: 'Cancel VIP Offer',
  you_save: 'You save {amount}',
  you_save_on_order: 'You save {amount} on your order',
  you_save_available: 'Save {amount} on your order with the exclusive VIP offer',
  free_trial_then_price: '{duration} {type} free trial, then {price}/{interval}',
  free_trial_period_short: '{duration} {type} free',
  click_to_apply: 'Click to apply',
  please_select_shipping_country: 'Please select a country to see available shipping methods',
  invalid_phone_number: 'Invalid phone number',
  click_errors_to_navigate: 'Click to navigate to error',
  pickup_point: 'Pickup Point',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  promotion_code_usage_limit_reached: 'This promotion code has reached its usage limit',
  promotion_code_first_time_only: 'This promotion code is only valid for first-time customers',
  promotion_code_invalid_email: 'This promotion code is not valid for your email address',
  promotion_code_cannot_apply: 'This promotion code cannot be applied',
  promotion_code_already_applied: 'This promotion is already applied',
  promotion_code_expired: 'This promotion code has expired',
  promotion_code_cannot_remove_auto: 'Cannot remove automatically applied promotions',
  promotion_code_remove_failed: 'Failed to remove promotion code',
  remove: 'Remove',
  pickup_select_point: 'Select pickup point',
  pickup_select_point_description: 'Choose a pickup point near you',
  pickup_click_to_select: 'Click to select',
  pickup_change_point: 'Change pickup point',
  pickup_change: 'Change',
  pickup_opening_hours: 'Opening hours',
  pickup_closed: 'Closed',
  pickup_point_error: 'An error occurred while selecting the pickup point',
  pickup_view_list: 'List view',
  pickup_view_map: 'Map View',
  pickup_open_map: 'Open Map',
  pickup_open_map_description: 'Click to open the interactive map',
  pickup_no_points_found: 'No pickup points found in this area',
  cancel: 'Cancel',
  order_confirmed: 'Order Confirmed',
  view_order_details: 'View Order Details',
  back_to_portal: 'Back to Portal',
  customer_details: 'Customer Details',
  customer_email: 'Email',
  customer_id_label: 'Customer ID',
  customer_first_name: 'First Name',
  customer_last_name: 'Last Name',
  customer_locale: 'Language',
  marketing_consent: 'Marketing Preferences',
  marketing_accepted: 'Subscribed to marketing',
  marketing_declined: 'Not subscribed to marketing',
  customer_created_at: 'Customer Since',
  order_status_label: 'Order Status',
  order_status_paid: 'Paid',
  order_status_pending: 'Pending',
  order_status_cancelled: 'Cancelled',
  post_purchase: {
    title: 'We found those offers just for you',
    view_deal: 'View Deal',
    get_deal_now: 'Get Deal Now',
    bundle_content: '{count, plural, =0 {no item} =1 {# item} other {# items}}',
    adding_to_cart: 'Processing...',
    vip_only: 'VIP Only',
    products: '{count, plural, =0 {No Products} =1 {# Product} other {# Products}}',
    skip: 'skip',
    skip_addition: 'go to your recap',
    exclusive_offer: 'Exclusive One-Time Offer',
    offer_expires_in: 'Offer Expires In',
    minutes: 'min',
    save: 'Save',
    secure_checkout: 'Secure Checkout',
    safe_payment: 'Buyer Protection Guaranteed',
    limited_time_offer: 'Limited Time Offer',
    previous: 'Previous',
    no_thanks: 'No Thanks',
    offer_count: 'Offer {current} of {total}',
    special_offer_title: 'Special Offer For You',
  },
  vip_post_purchase: {
    title: 'You still have time!',
    subtitle: 'Subscribe to our club membership, and win big!',
    action_cancel: 'No, thanks',
    action_subscribe: 'Subscribe',
    savings: 'You save {amount}',
    offer_title: 'Exclusive One-Time Offer',
    offer_description: '',
  },
  billing_plan: 'Billing Plan',
  customer: 'Customer',
  current_period: 'Current Period',
  trial_period: 'Trial Period',
  cancellation_notice: 'Cancellation Notice',
  subscription_cancellation_end_period:
    'This subscription will be canceled at the end of the current period.',
  created: 'Created',
  product_id: 'Product ID',
  resuming: 'Resuming...',
  resume_subscription: 'Resume Subscription',
  canceling: 'Canceling...',
  cancel_subscription: 'Cancel Subscription',
  my_subscriptions: 'My Subscriptions',
  subscriptions: 'subscriptions',
  no_active_subscriptions: "You don't have any active subscriptions.",
  active: 'Active',
  trial: 'Trial',
  loading_subscriptions: 'Loading your subscriptions...',
  qty: 'Qty',
  id: 'ID',
  by_canceling: 'By canceling, you will:',
  lose_club_advantages: 'Lose all advantages of being a member of the club',
  lose_accumulated_credits: 'Lose all credits you have accumulated until now',
  lose_promotion_code: 'Lose your personal promotion code with exclusive promotions on all the shop',
  confirm_proceed: 'Are you sure you want to proceed?',
  cancel_club_membership: 'This will cancel your club membership at the end of the current billing cycle.',
  cancel_subscription_notice: 'This will cancel your subscription at the end of the current billing cycle.',
  keep_subscription: 'Keep Subscription',
  yes_lose_benefits: 'Yes, I want to lose all benefits of being a member of the Subclub',
  yes_cancel: 'Yes, Cancel',
  cancel_subscription_title: 'Cancel Subscription',
  membership: 'Membership',
  related_orders: 'Related Orders',
  related_orders_description: 'Orders made through post-purchase offers',
  order_status: 'Status',
  order_total: 'Total',
  order_items: 'Items',
  order_type: 'Type',
  view_order: 'View Order',
  order_item_count: '{count, plural, =1 {# item} other {# items}}',
  related_order_from: 'From {offerType} offer',
  no_related_orders: 'No related orders',
  total_with_related_orders: 'Total with related orders',
  discount_applied: 'Discount applied',
  paid: 'Paid',
  pending: 'Pending',
  processing: 'Processing',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'Pickup ID',
        name: 'Pickup Name',
        street: 'Pickup Address',
        type: 'Pickup Type',
        city: 'Pickup City',
        postal_code: 'Pickup Postal Code',
        country: 'Pickup Country',
        carrier: 'Pickup Carrier',
        code: 'Pickup Code',
        latitude: 'Pickup Latitude',
        longitude: 'Pickup Longitude',
      },
    },
  },
};

export type Messages = typeof MESSAGES_EN;
